export default "__VITE_ASSET__daa1a6f2__"